import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.Paint;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "Paint.Phaser.IntroductionScene.1",
            "Paint.Phaser.IntroductionScene.2",
            "Paint.Phaser.IntroductionScene.3",
            "Paint.Phaser.IntroductionScene.4",
            "Paint.Phaser.IntroductionScene.5",
            "Paint.Phaser.IntroductionScene.6",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/PaintGame/scenes/GameIntro.ts